export default __webpack_public_path__ + "images/ab89a2a3d8b31286cc4fa3fad55ef041-create-your-own-affirmations.svg";